import {message} from 'antd';
import {getApi} from './request.js';
import dayjs from 'dayjs'
import {getGoogleLang} from '@/services/userApi';
import {Toast} from "antd-mobile";

const getLocalKey = () => {
    const lang = localStorage.getItem('umi_locale');
    return `${lang}-google-lang`;
};

export const ORDER_STATUS = {
    1: '成功',
    2: '失败',
    3: '待支付',
    4: '已退款',
    5: '待审核'
}
export const UserAuth = {
    0: '未实名',
    1: '已实名'
};

export const locale = localStorage.getItem('umi_locale') || 'en-US';

export const getLocalImage = (imgName: string) => require(`@/assets/${locale}/${imgName}`);

export const copyLink = async (link: string) => {
    try {
        if (navigator.clipboard?.writeText) {
            await navigator.clipboard.writeText(link);
            // message.success('复制成功');
        } else {
            // 降级方案
            const textArea = document.createElement('textarea');
            textArea.value = link;
            document.body.appendChild(textArea);
            textArea.select();
            document.execCommand('copy');
            document.body.removeChild(textArea);
            // message.success('复制成功');
        }
        Toast.show({
            content: "复制成功",
            duration: 1500,
        });
    } catch (error) {
        console.error('复制链接时出错:', error);
        message.error('复制失败，请手动复制');
    }
};

export const getQuery = () => {
    const queryParams = new URLSearchParams(location.search);
    const queryObj = Object.fromEntries(queryParams.entries());
    return queryObj;
};

export const getLocalItem = (key) => {
    // 校验 key 参数合法性（避免非字符串 key 导致的存储异常）
    if (typeof key !== 'string' || key.trim() === '') {
        console.error('key 必须是非空字符串');
        return '';
    }
    const data = localStorage.getItem(key);
    if (data === null) {
        return '';
    }
    try {
        return JSON.parse(data);
    } catch (error) {
        console.warn(`解析 key 为 ${key} 的数据失败，返回原始值`, error);
        return data;
    }
};

export const setLocalItem = (key, data) => {
    localStorage.setItem(key, JSON.stringify(data));
};

const filterLangs = (keys, langs) => {
    const data = {};
    keys.map((item) => {
        if (langs[item]) {
            data[item] = langs[item];
        }
    });
    return data;
};

export const getLang = async ({keys, ...rest}) => {
    // string 'title',arr:['title','desc'];
    const googleLocalKey = getLocalKey();
    if (!keys) {
        return '';
    }

    const localLang = getLocalItem(googleLocalKey);
    //过滤最简单的格式
    if (localLang?.[keys]) {
        return localLang[keys];
    }
    let text = {}, oldData = {};
    //如果是批量翻译
    if (Array.isArray(keys)) {
        //筛选出 本地没有的字段进行请求
        const newkeys = keys.filter((item) => item && !localLang?.[item]);
        if (newkeys.length < 1) {
            return filterLangs(keys, localLang);
        }
        newkeys.map((item) => {
            text[item] = item
        }); //组合请求的text格式为{key:value}；
    } else {
        text = keys;
    }

    //如果没有新字段请求返回本地数据
    if (!text || Object.keys(text).length < 1) {
        return filterLangs(keys, localLang);
    }
    //如果翻译的是简体中文 === 没翻译
    const lang = localStorage.getItem('umi_locale');
    if (lang === 'zh-CN') {
        const newData = {...localLang, ...text};
        setLocalItem(googleLocalKey, newData);
        return filterLangs(keys, newData);
    }

    try {
        const googleLang = await getLangFromGoogle({text, ...rest});
        return filterLangs(keys, googleLang);
    } catch (error) {
        console.error('获取翻译内容失败:', error);
        message.error('翻译服务暂时不可用');
        return filterLangs(keys, localLang || {});
    }
};

export const getLangFromGoogle = async ({text = {}, source = 'zh-CN', platform = 1}) => {
    const googleLocalKey = getLocalKey();
    const localLang = getLocalItem(googleLocalKey);

    try {
        const data = await getApi({api: getGoogleLang, params: {platform, text, source}});
        const translatedText = typeof text === 'string' ? {[text]: data} : data;

        const newJsonStr = JSON.stringify({...localLang, ...translatedText});
        const newLang = JSON.parse(newJsonStr);
        setLocalItem(googleLocalKey, newLang);
        return newLang;
    } catch (error) {
        console.error('调用谷歌翻译API失败:', error);
        message.error('翻译服务暂时不可用');
        return localLang || {};
    }
};
export const convertDateFormat = (dateStr) => {
    const date = new Date(dateStr);

    // 获取月份并补零（月份从0开始，需+1）
    const month = String(date.getMonth() + 1).padStart(2, '0');

    // 获取日期并补零
    const day = String(date.getDate()).padStart(2, '0');
    // 拼接成 "11.20" 格式并返回
    return `${month}.${day}`;
}
export const blow18yYards = (current) => {
    // 计算18年前的今天
    const eighteenYearsAgo = dayjs().subtract(18, 'years');
    // 不能选择未来的日期
    // 不能选择18岁生日之后的日期
    return current && (current > dayjs().endOf('day') ||
        current > eighteenYearsAgo.endOf('day'))
};
export const IMAGE_BASE_URL = process.env.NODE_ENV === 'production' ? 'https://findtrader.net/' : 'http://47.236.134.12/';

/**
 * 批量预加载图片
 * @param {string[]} imageUrls - 图片URL数组
 * @returns {Promise<{success: string[], failed: string[]}>} 包含成功和失败URL的Promise
 */
export const preloadImages = (imageUrls) => {
    // 存储所有图片加载的Promise
    const promises = imageUrls.map(url => {
        return new Promise((resolve, reject) => {
            const img = new Image();

            // 图片加载成功
            img.onload = () => {
                // 可以在这里添加图片尺寸校验等逻辑
                resolve(url);
            };

            // 图片加载失败
            img.onerror = () => {
                reject(url);
            };

            // 开始加载图片
            img.src = url;
        });
    });

    // 等待所有Promise完成（无论成功或失败）
    return Promise.allSettled(promises).then(results => {
        const success = [];
        const failed = [];

        // 分类成功和失败的图片URL
        results.forEach(result => {
            if (result.status === 'fulfilled') {
                success.push(result.value);
            } else {
                failed.push(result.reason);
            }
        });

        return {success, failed};
    });
};

// 检测是否为移动设备
export const isMobile = () => {
    if (typeof window === 'undefined') return false;

    const userAgent = window.navigator.userAgent.toLowerCase();
    const mobileKeywords = ['mobile', 'android', 'iphone', 'ipad', 'ipod', 'ios', 'windows phone'];

    return mobileKeywords.some(keyword => userAgent.includes(keyword));
};

// 获取基础域名（不含/m后缀）
export const getBaseDomain = () => {
    // 直接返回协议+主机名，不包含任何路径
    return `${window.location.protocol}//${window.location.host}`;

};

